<template>
  <div> 

    <div class="ibox mx-2">
      <div class="ibox-title">
        Maestro V2
      </div>
      <div class="ibox-content">
        <div class="row">
          <div class="col-sm-3" v-for="page in pages" :key="page.name">
            <router-link tag="div" :to="`/admin/maestro/${page.path}`" class="card card-admin">
              <div class="card-body text-center">
                <strong>
                  {{ page.name }}
                </strong>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="ibox mx-2">
      <div class="ibox-title">
        Maestro V3
      </div>
      <div class="ibox-content">
        <div class="row">
          <div class="col-sm-3" v-for="page in v3Pages" :key="page.name" :title="page.title">
            <router-link tag="div" :to="`/admin/maestro/${page.path}`" class="card card-admin">
              <div class="card-body text-center">
                <strong>
                  {{ page.name }}
                </strong>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: () => ({
      pages: [
        { name: 'Consultas', path: 'consults' },
        { name: 'Requisições', path: 'requests' },
        { name: 'Multas', path: 'tickets' },
        { name: 'Histórico de Multas', path: 'ticket_histories' },
        { name: 'Descrições de Multas', path: 'ticket_descriptions' },
        { name: 'Crono', path: 'chronotachographs' },
        { name: 'Histórico de Crono', path: 'chronotachograph_histories' },
        { name: 'Taxas', path: 'fees' },
        { name: 'Histórico de Taxas', path: 'fee_histories' },
        { name: 'Eventos', path: 'events' },
        { name: 'Scraping Services', path: 'scraping_services' },
        { name: 'Motoristas', path: 'drivers' },
        { name: 'Veículos', path: 'vehicles' },
        { name: 'Indicação de Condutores', path: 'driver-indications' },
        { name: 'Status de Indicação', path: 'driver_indication_statuses' }
      ],
      v3Pages: [
        { name: 'Orders', path: 'orders' },
        { name: 'Items', path: 'items' },
        { name: 'Consults', path: 'manager-consults', title: 'Gerenciamento de consultas realizadas' }
      ]
    }),
    name: 'Index',
  }
</script>

<style scoped>

  .card-admin {
    cursor: pointer;
  }
  .card-admin:hover {
    transition: background-color 1s;
    background: #8080803d;
  }
</style>
